export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12213.60d235ab.jpg";